export default __webpack_public_path__ + "assets/wizard-order-65f5961103074126a2d6f5564ed9b205.svg";